export default class TextareaTip {
	constructor({ elements }) {
		elements.forEach((el) => {
			// wire up listener
			if (el.dataset.textareaTip != null) {
				const inputElement = el.nextSibling;
				inputElement.insertAdjacentHTML(
					'afterend',
					`<div class="tip-container hide"><div class="emoji">&#128161;</div><div class="textarea-tip"><strong>Tip: </strong>${el.dataset.textareaTip}</div></div>`
				);
				inputElement.addEventListener('keyup', () => {
					inputElement.nextSibling.classList.remove('hide');
				});
			}
		});
	}
}
